import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const checkStatus = React.createContext({});
export let checkStatusMachine: any;

const MODULE_NAME = 'machines.checkStatus';

export const useSMCheckStatus = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  checkStatusMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(checkStatusMachine);

  return {
    checkStatusMachine,
    checkStatusState: state,
    checkStatusSend: send,
  };
};
